const enum ReimbursementProduct {
  NotSpecified = 0,
  PremiumPlusOutOfPocketExpenses = 1,
  PremiumsOnly = 2,
}

export default ReimbursementProduct
